<template>
    <div>
        <center-title>{{$t("message.csales.title")}}</center-title>
        <div class="center-analysis-content">
            <!--  -->
            <el-tabs v-model="activeName" @tab-click="handleClick">
                <el-tab-pane :label="$t('message.csales.tabs1')" name="1">
                    <analysis-search
                        @handle-search="handleSearch">
                    </analysis-search>
                </el-tab-pane>
                <el-tab-pane :label="$t('message.csales.tabs2')" name="2">
                    <analysis-chart></analysis-chart>
                </el-tab-pane>
            </el-tabs>
            <analysis-dialog
				@goPpages="handleCurrent"
			>
                <template #component>
                    <analysis-table
                        :prop-attr="sortAttr"
                        :order="sortMode"
                        :check-list="checkList"
                        @handleSort="handleSort">
                    </analysis-table>
                  <!--  <table-pagination
                        :current-page="page.current_page"
                        :page-count="page.last_page"
                        @current-change="handleCurrent">
                    </table-pagination> -->
                </template>
            </analysis-dialog>
        </div>
    </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex"

export default {
    data() {
        return {
            activeName: "1",
            checkList: [],
            tableParams: {},
            sortAttr: '',
            sortMode: ''
        }
    },
    computed: mapState({
        power: state => state.user.power,
        page: state => state.user.page
    }),
    components: {
        centerTitle: () => import("@/components/center/centerTitle"),
        analysisChart: () => import("@/components/center/analysisChart"),
        analysisSearch: () => import("@/components/center/analysisSearch"),
        analysisTable: () => import("@/components/center/analysisTable"),
        analysisDialog: () => import("@/components/center/analysisDialog"),
        tablePagination: () => import('@/components/center/table-pagination')
    },
    methods: {
        ...mapMutations([
            "setDepartmentParent",
            "setGoodsOptions",
            "setAnalysisOrder",
            "setAnalysisBrand",
            "setAnalysisDepartment",
            "setAnalysisChart"
        ]),
        ...mapActions([
            "getDepartmentParent",
            "getGoodsOptions",
            "getAnalysisOrder",
            "getAnalysisBrand",
            "getAnalysisChart",
            'getAnalysis'
        ]),
        handleClick(tab, event){
            let start_date = sessionStorage.getItem("start_date") || "",
            end_date = sessionStorage.getItem("end_date") || "";
            if(tab.name === "2"){
                this.getAnalysisChart({
                    release: start_date,
                    relend: end_date
                });
            }else if(tab.name == "1"){
            }
        },
		//获取表格数据
        getTable(search, attr, mode, page = 1) {
            search.attr = attr;
            search.mode = mode;
            search.page = page;
            this.getAnalysis(search);
        },
		// handleCurrent(page){
		// 	// console.log(1111111,page)
		// },
        handleSearch(search, checks) {
            this.tableParams = search;
            this.checkList = checks;
            this.getTable(search, this.sortAttr, this.sortMode);
        },
        handleSort({ column, prop, order }){
            this.sortAttr = prop;
            this.sortMode = order;
            this.getTable(this.tableParams, prop, order);
        },
        handleCurrent(current){
            this.getTable(this.tableParams, this.sortAttr, this.sortMode, current);
        }
    },
    beforeRouteEnter (to, from, next) {
        next(vm => {
			setTimeout(() => {
				let allow = vm.power.includes(0) || vm.power.includes(14)
				if(allow){
				    vm.getGoodsOptions(); // 商品选项
				    vm.getAnalysisOrder(); // 订单号选项
				    vm.getAnalysisBrand(); // 品牌
				    vm.getDepartmentParent(); // 获取分公司分行
				}else{
				    vm.$router.back();
				    return false;
				}
			}, 500)
			
            // if(vm.power.includes(111)){
            //     vm.$router.back();
            //     return false;
            // }else{
            //     vm.getGoodsOptions(); // 商品选项
            //     vm.getAnalysisOrder(); // 订单号选项
            //     vm.getAnalysisBrand(); // 品牌
            //     vm.getDepartmentParent(); // 获取分公司分行
            // }
        })
    },
    beforeRouteLeave (to, from, next) {
        sessionStorage.removeItem("start_date");
        sessionStorage.removeItem("end_date");
        this.setDepartmentParent([]);
        this.setGoodsOptions([]);
        this.setAnalysisOrder([]);
        this.setAnalysisBrand([]);
        this.setAnalysisDepartment([]);
        this.setAnalysisChart({});
        next();
    }
}
</script>

<style scoped>
.center-analysis-content{
    padding: 20px;
    background: #fff;
}
</style>
